module.exports = __webpack_public_path__ + "img/subscribed2.6c0bbbc2.svg";